import JsPDF from 'jspdf';
import JsBarcode from 'jsbarcode';

import { GetItemConditionLabel } from '../../constants/products';

const genrateFNSkuBarCode = (sku) => {
  const canvas = document.createElement('canvas');
  JsBarcode(canvas, sku, {
    format: 'CODE128A',
    text: sku,
    font: 'sans-serif',
    fontSize: 40,
    textAlign: 'center',
    width: 5,
    // height: 85,
    margin: 1,
    displayValue: false
  });
  return canvas.toDataURL('image/png');
};

const formatpdf = (pdfDoc, barcode, fnsku, packageQuantity, condition, expiryDate, title, companyName, item_condition) => {
  pdfDoc.setFontSize(7);
  pdfDoc.addImage(barcode, 'PNG', 6, 6, 132, 28); // x, y, width, height

  // FNSKU and expiry
  pdfDoc.setFontSize(6);
  pdfDoc.text(`${fnsku}`, 55, 42);

  // Break title into two lines
  const firstLine = title.substring(0, 42);
  const secondLine = title.length > 42
    ? title.length > 84
      ? `${title.substring(42, 84)}...`
      : title.substring(42)
    : '';

  pdfDoc.setFontSize(5.5);
  pdfDoc.text(firstLine, 6, 51);  // Line 1
  if (secondLine) {
    pdfDoc.text(secondLine, 6, 60);  // Line 2
  }

  // set text to bold
  pdfDoc.setFontStyle('bold');
  const itemConditionLabel = GetItemConditionLabel(item_condition);
  pdfDoc.text(`${itemConditionLabel || 'NEW'}`, 6, 68);
  if (expiryDate) {
    pdfDoc.text(`exp: ${expiryDate}`, 75, 68);
  }
  pdfDoc.setFontStyle('normal');
};

const instructionLabel = (pdfDoc, username, prepInstruction, packageQuantity, title, bundleQty, numberOfLabels) => {
  let y = 0;
  const centerX = 81;
  const x = 8;


  let titleLines = pdfDoc.splitTextToSize(title, 250);

  titleLines = titleLines.slice(0, 2);

  pdfDoc.setFont('helvetica', 'normal');

  y += 6;
  pdfDoc.setFontSize(12);
  // pdfDoc.setFontStyle('bold');
  // pdfDoc.text(username, centerX, y, 'center');

  const instructions = pdfDoc.splitTextToSize(`Prep. Instructions: ${prepInstruction ? prepInstruction.toString() : 'N/A'}`, 170);
  y += 10;
  pdfDoc.setFontSize(8);
  pdfDoc.setFontStyle('bold');
  pdfDoc.text(instructions, x, y);
  y += 5;

  const product = pdfDoc.splitTextToSize(`${titleLines}`, 170);
  prepInstruction.toString()?.length > 40 ? y += 22 : y += 15;

  pdfDoc.setFontSize(7);
  pdfDoc.setFontStyle('normal');
  pdfDoc.text(product, x, y);
  y += 20;
  pdfDoc.setFontSize(8);
  pdfDoc.setFontStyle('bold');
  pdfDoc.text(`Total Bundles: ${numberOfLabels}`, x, y);
  y += 10;
  pdfDoc.text(`Bundle Quantity: ${bundleQty || 1}`, x, y);
  pdfDoc.setFontSize(7);
  pdfDoc.setFontStyle('normal');


  return pdfDoc;
};

const productLabel = ({
  fnsku,
  title,
  condition,
  packageQuantity,
  expiryDate,
  numberOfLabels,
  bundleQty,
  username,
  companyName,
  prepInstruction = [],
  item_condition
}) => {
  const pageWidth = 144;  // 2 inches
  const pageHeight = 72;  // 1 inch
  let pdfDoc = new JsPDF('landscape', 'pt', [pageWidth, pageHeight]);

  pdfDoc = instructionLabel(pdfDoc, username, prepInstruction, packageQuantity, title, bundleQty, numberOfLabels);

  const barcode = genrateFNSkuBarCode(fnsku);

  for (let index = 0; index < numberOfLabels; index += 1) {
    pdfDoc.addPage([pageWidth, pageHeight], 'landscape');
    formatpdf(pdfDoc, barcode, fnsku, packageQuantity, condition, expiryDate, title, companyName, item_condition);
  }
  window.open(pdfDoc.output('bloburl'), '_blank');
};

export default productLabel;